import React from 'react';

/**
 * Material Symbols Icon component
 * @param {string} name - Icon name from Material Symbols
 * @param {string} className - Additional CSS classes
 * @param {string} size - Icon size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
 * @param {boolean} filled - Whether to use filled variant
 */
const Icon = ({ 
  name, 
  className = '', 
  size = 'md',
  filled = false,
  ...props 
}) => {
  const sizeClasses = {
    xs: 'text-sm',
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
    '2xl': 'text-4xl',
  };

  return (
    <span 
      className={`material-symbols-outlined select-none ${sizeClasses[size]} ${className}`}
      style={{ fontVariationSettings: filled ? "'FILL' 1" : "'FILL' 0" }}
      {...props}
    >
      {name}
    </span>
  );
};

export default Icon;
